import { motion } from "framer-motion";
import scrollArrow from "@/assets/brand/scroll-arrow.svg";

interface ScrollIndicatorProps {
  onClick?: () => void;
  className?: string;
}

const ScrollIndicator = ({ onClick, className = "" }: ScrollIndicatorProps) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1, delay: 1.2 }}
      className={`flex flex-col items-center cursor-pointer ${className}`}
      onClick={onClick}
    >
      {/* Animated arrow */}
      <motion.img
        src={scrollArrow}
        alt="Scroll"
        className="w-10 h-auto opacity-60 hover:opacity-100 transition-opacity mx-auto -mt-4"
        animate={{ y: [0, 6, 0] }}
        transition={{
          duration: 1.8,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      />
    </motion.div>
  );
};

export default ScrollIndicator;
